module.exports = __webpack_public_path__ + "static/V2-Cartons-Purifier&Pro-14e3c41fadc66869b3f0b67f0a30fa34.png";